<template>
  <div id="app">
    <header-nav></header-nav>
    <div  class="main-content">
      <router-view :key="$route.fullPath"></router-view>
    </div>

    <footer-copyright></footer-copyright>
  </div>
</template>

<script>
  import HeaderNav from './components/Header'
  import FooterCopyright from './components/Footer'

export default {
  name: 'App',
  components: {
    HeaderNav,
    FooterCopyright
  }
}
</script>

<style>
  .main-content{
    padding-top: 90px;
  }
#app {
  font-family: "Microsoft Yahei", Arial, tahoma, Helvetica, sans-serif;
  /*font-family: Microsoft YaHei,'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #332c2b;
}
</style>



// WEBPACK FOOTER //
// src/App.vue